/**
 * @file confirmation-dialog.component.ts
 */
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MultilingualService } from 'src/app/core/services/multilingual/multilingual.service';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>, public readonly multilingualService: MultilingualService) { }

  ngOnInit(): void {
  }

}
